import React from  "react"

const date = new Date(); 
// {/*This object is to init */}

 const Footer = () => <footer>


    <div><h3>&copy; all rights reserved | studioFrank {date.getFullYear()}</h3></div>
</footer>
export default Footer;